<template>
  <div
    class="infinity-select-preview"
    :class="[{ isMultiple }]"
    ref="infinitySelectPreview"
    @click="$emit('click')"
  >
    <div
      v-if="!__selected || __selected.length === 0"
      class="infinity-select-preview-placeholder"
    >
      {{ placeholder }}
    </div>
    <template v-else>
      <template v-if="isMultiple">
        <span
          class="item"
          v-for="(item, index) in __selected"
          :key="item.value"
        >
          <span class="text">{{ item.label }}</span>
          <Icon
            class="delete-btn"
            type="md-close"
            @click.stop="deleteItem(index, item)"
          ></Icon>
        </span>
      </template>
      <div v-else class="infinity-select-preview-text">
        {{ __selected.length > 0 ? __selected[0].label : "" }}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "InfinitySelectPreview",
  props: {
    value: Array,
  },
  data() {
    return {
      mo: null,
      oldHeight: 34,
    };
  },
  computed: {
    isMultiple() {
      return this.$parent.multiple;
    },
    __selected() {
      return JSON.parse(JSON.stringify(this.value));
    },
    placeholder() {
      return this.$parent.placeholder;
    },
  },
  mounted() {
    this.mo = new MutationObserver(this.onResize);
    this.mo.observe(this.$refs.infinitySelectPreview, {
      childList: true,
    });
  },
  beforeDestroy() {
    this.mo.disconnect();
  },
  methods: {
    deleteItem(index, item) {
      this.__selected.splice(index, 1);
      this.$emit("input", this.__selected);
      this.$emit("on-change", this.__selected);
      this.$emit("on-delete-selected", JSON.parse(JSON.stringify(item)));
    },
    onResize() {
      const newHeight = this.$refs.infinitySelectPreview.offsetHeight;
      if (newHeight !== this.oldHeight) {
        const selectDrop = this.$parent.$refs.infinitySelectOptionsWrapper;
        const newTop = newHeight + 4 + "px";
        selectDrop.style.top = newTop;
        this.oldHeight = newHeight;
      }
    },
  },
};
</script>

<style scoped lang="stylus">
.infinity-select-preview
  display block
  box-sizing border-box
  outline none
  user-select none
  cursor pointer
  position relative
  background-color #fff
  border-radius 4px
  border 1px solid #dcdee2
  transition all .2s ease-in-out
  width 100%
  padding 0 5px
  height 34px

  .infinity-select-preview-placeholder
    position absolute
    display flex
    align-items center
    height 100%
    color #999

  &:hover
    border-color #57a3f3

  .infinity-select-preview-text
    display flex
    align-items center
    height 100%

  &.isMultiple
    min-height 34px
    padding-bottom 3px
    height auto

  .selected-item
    height 22px
    line-height 22px
    margin 3px 4px 2px 0

  .item
    position relative
    display inline-flex
    align-items center
    border 1px solid #e8eaec
    border-radius 3px
    background #f7f7f7
    font-size 12px
    height 26px
    padding 0px 20px 0px 8px
    margin 3px 5px 0 0

    .delete-btn
      position absolute
      right 4px
</style>
